import { render, staticRenderFns } from "./info_card.vue?vue&type=template&id=48f62aee&scoped=true"
import script from "./info_card.vue?vue&type=script&lang=js"
export * from "./info_card.vue?vue&type=script&lang=js"
import style0 from "./info_card.vue?vue&type=style&index=0&id=48f62aee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f62aee",
  null
  
)

export default component.exports